/* eslint react/prop-types: 0 */
import React from 'react';
import FilterBtn from './FilterBtn';
import { formatMoney, formatPrize } from '../../../utils/money';
import { numericAndDashSort, zeroToDash } from '../../../utils/number';
import Abbr from '../../../shared/Abbr';

const columns = (onFilterClick, selectedFilter, hasAccess) => [
    {
        key: 'raceType',
        header: 'lifetime record',
        cell: ({ raceType }) => (
            <FilterBtn
                raceType={raceType}
                onClick={onFilterClick}
                isSelected={raceType === selectedFilter}
                hasAccess={hasAccess}
            />
        ),
    },
    {
        key: 'starts',
        header: 'runs',
    },
    {
        key: 'wins',
        header: () => (
            <Abbr title="wins" breakpoint="fromMedium">
                wins runs
            </Abbr>
        ),
        cell: ({ wins, starts }) => (
            <span>
                {wins}
                <span className="hidden-md-up">
                    /{starts}
                </span>
            </span>
            ),
    },
    {
        key: '2nds',
    },
    {
        key: '3rds',
    },
    {
        key: 'winPrize',
        header: 'winnings',
        cell: ({ netWinPrize }) => formatMoney(netWinPrize),
    },
    {
        key: 'totalPrize',
        header: 'prize',
        cell: ({ netTotalPrize }) => formatPrize(netTotalPrize),

    },
    {
        key: 'totalPrizeFormatted',
        header: 'earnings',
        cell: ({ netTotalPrize }) => formatMoney(netTotalPrize),
    },
    {
        key: 'or+',
        header: 'or',
        cell: zeroToDash('or+'),
        sortFn: numericAndDashSort('or+'),
    },
    {
        key: 'bestTs',
        cell: zeroToDash('bestTs'),
    },
    {
        key: 'bestRpr',
        cell: zeroToDash('bestRpr'),
    },
    {
        key: 'myRating',
        header: 'best mr',
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/form/raceRecords/columns.jsx